'use client';

import { useEffect, useRef, useState } from 'react';
import { RecordRelativeValueChart } from '@/app/(authenticated)/report/components/Visualizations';
import { recordChartBarsThatFit } from '@/lib/recordChartFit';
import { SAMPLE_RECORD } from './sampleMarkers';

// What shows until the chart is first measured, and all that shows without JavaScript: as
// many as fit a 320 px phone, so it doesn't scroll there either.
const UNMEASURED = 5;

// The app's record chart, filled with as many sample markers as fit its width without
// scrolling, and recounted whenever that width changes. Without its hover tooltips, which
// would widen the chart past what recordChartBarsThatFit counts.
export function RecordChartPreview() {
  const ref = useRef<HTMLDivElement>(null);
  const [count, setCount] = useState(UNMEASURED);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new ResizeObserver(([entry]) => {
      const remPx =
        parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      setCount(
        Math.min(
          SAMPLE_RECORD.length,
          recordChartBarsThatFit(entry.contentRect.width, remPx)
        )
      );
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref}>
      <RecordRelativeValueChart
        markers={SAMPLE_RECORD.slice(0, count)}
        tooltips={false}
      />
    </div>
  );
}
